// @flow
import React, { lazy } from 'react'
import { PrivateRoute } from 'src/common/components'

const GlobalSettingsPage = lazy(() => import('src/modules/globalSettings/globalSettingsPage'))

export default [
  <PrivateRoute exact={true} path="/global-settings" component={GlobalSettingsPage} key="global-settings"/>,
]
